import React from 'react';

const BS_Inputs = () => {
    return (
        <div>
            <h1>BS_Inputs Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Inputs;
